import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { centsToDollars } from '../../utils/formatters'

import styles from './Header.module.scss'

const RichCheckoutHeader = ({ cartQuantity, orderNumber, subtotal, total, className }) => {
  const classNames = cn(styles.header, className)

  return (
    <div className={classNames}>
      <div className={styles.grandTotalRow}>
        {centsToDollars(total)}
      </div>
      <div className={styles.orderInfoRow}>
        <span>
          {`Order # ${orderNumber}`}
        </span>
        <span>•</span>
        <span>
          {`Subtotal: ${centsToDollars(subtotal)} (${cartQuantity})`}
        </span>
      </div>
    </div>
  )
}

RichCheckoutHeader.defaultProps = {
  cartItems: [],
  orderNumber: 0,
  subtotal: 0,
  total: 0,
}

RichCheckoutHeader.propTypes = {
  cartItems: PropTypes.array,
  orderNumber: PropTypes.number,
  subtotal: PropTypes.number,
  total: PropTypes.number,
}

export default RichCheckoutHeader
